import React from "react";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import Social from "./Social";
import GetAppIcon from "@material-ui/icons/GetApp";

const Contact = () => {
  return (
    <div className="contactForm w-100">
      <h1 className="title">Contact Me</h1>

      <Social
        link="https://www.linkedin.com/in/rakeshnayak360"
        target="_blank"
        Icon={GitHubIcon}
        text="rakeshnayak360"
      />

      <Social
        link="https://github.com/rakeshnayak360"
        target="_blank"
        Icon={LinkedInIcon}
        text="rakeshnayak360"
      />

      <Social
        link="mailto:rakeshnayak360@gmail.com"
        target="_blank"
        Icon={MailOutlineIcon}
        text="rakeshnayak360@gmail.com"
      />

      <a
        href="https://drive.google.com/file/d/1nYhmGUqGf4qVrDrkgRrsiR6f0YsGZgkg/view?usp=sharing"
        className="resumeDownloadBtn mt-3"
        target="_blank"
        rel="noreferrer"
      >
        <GetAppIcon />
        Download Resume
      </a>
    </div>
  );
};

export default Contact;
